module.exports = __webpack_public_path__ + "static/media/CHAP1-DOUBLE-PHOTO.7d4d6b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP1-DOUBLE-PHOTO.png
// module id = 265
// module chunks = 0